<template>
  <div class="page-container">
    <Filter ref="filterRef" :params="params" @search="searchData"></Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage">
      <el-table-column prop="robotId" :label="$t('activity.packetjoin.robotCode')" />
      <!-- <el-table-column prop="productName" label="产品名称" /> -->
      <el-table-column prop="modelName" :label="$t('equipment.cabinet.specModel')" />
      <!-- <el-table-column prop="cabinetId" :label="$t('equipment.cabinet.ctrlCode')" /> -->
      <el-table-column prop="cabinetId" :label="$t('equipment.cabinet.ctrlCode')" width="100">
        <template #default="scope">
          <span v-if="scope.row.cabinetId?.length > 4 && ![undifined, 'undifined', 'Invalid-ID'].includes(scope.row.cabinetId)">{{scope.row.cabinetId}}</span>
          <el-popover
            v-else
            placement="top-start"
            :width="400"
            trigger="hover"
            title=""
          >
            <template #default>
              <el-descriptions title="" column="1" border>
                <el-descriptions-item :label="$t('error.alarm.reportinformation')">{{scope.row.cabinetId}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.solution')">{{$t('error.alarm.solutionInfo')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method1')">{{$t('error.alarm.methodInfo1')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method2')">{{$t('error.alarm.methodInfo2')}}</el-descriptions-item>
              </el-descriptions>
            </template>
            <template #reference>
              <span style="cursor: pointer;">
                {{ $t('error.alarm.pendingReport') }}
                <i class="el-icon-warning" style="margin-left: 6px;color: #E6A23C;"></i>
              </span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="version" label="软件版本" />
      <el-table-column prop="companyName" label="公司名称" width="150" /> -->
      <el-table-column prop="startTime" :label="$t('event.enable.enableStartTime')" width="190" />
      <el-table-column prop="endTime" :label="$t('event.enable.enableEndTime')" width="190" />
      <el-table-column
        prop="durationStr"
        :label="$t('event.enable.currentEnableDuration')"
        width="120"
      />
      <el-table-column
        prop="sumDurationStr"
        :label="$t('event.enable.totalEnableDuration')"
        width="150"
      />
      <el-table-column prop="queryTime" :label="$t('error.alarm.queryTime')" width="180" />
      <el-table-column :label="$t('activity.list.operation')" width="90">
        <template #default="scope">
          <el-button type="text" size="mini" @click="handleClick(scope.row)"
            >{{$t('event.crash.refreshStatus')}}</el-button
          >
        </template>
      </el-table-column>
    </Table>
  </div>
</template>

<script>
import { request } from "@/utils/request";
import { common } from "../../common/mixin";
import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
import dayjs from 'dayjs'
// import { useI18n } from 'vue-i18n'
// const { t } = useI18n()
export default {
  components: {
    Table,
    Filter
  },
  mixins: [common],
  data() {
    return {
      params: [{
        key: 'robotId',
        value: '',
        label: this.$t('activity.packetjoin.robotCode')
      },{
        key: 'cabinetId',
        value: '',
        label: this.$t('collect.healthscorelist.ctrlCabCode')
      },{
        type: "Date",
        key: "timeRange",
        value: [dayjs().subtract(7, 'day').format('YYYY-MM-DD') +' 00:00:00', dayjs().format('YYYY-MM-DD') +' 23:59:59'],
        label: this.$t('event.enable.enableStartTime'),
        options: {
          "type": "datetimerange",
          "format": "YYYY-MM-DD HH:mm:ss",
          "value-format": "YYYY-MM-DD HH:mm:ss",
          "range-separator": this.$t('activity.detail.to'),
          "start-placeholder": this.$t('activity.list.startDate'),
          "end-placeholder": this.$t('activity.list.endDate'),
          "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
        }
      }],
      query: {},
      page: 1,
      size: 10,
      total: 0,
      tableDataList: [
        // {
        //   robotId: "Zu7210101",
        //   productName: "JAKA Zu",
        //   modelName: "Zu 7",
        //   cabinetId: "123456789",
        //   version: "15.0.0",
        //   companyName: "汽车零部件公司",
        //   startTime: "2021-05-27 14:55:00.123",
        //   endTime: "2021-05-27 14:55:45.258",
        //   durationStr: "45.135s",
        //   sumDurationStr: "13547965.123",
        //   queryTime: "2021-05-24 17:48:20",
        // },
      ],
    };
  },
  created() {
  },
  mounted() {
    this.$refs.filterRef?.searchData()
  },
  methods: {
    getData() {
      request("getEventEnable", {
        ...this.query,
        page: this.page,
        size: this.size,
      })
        .then((data) => {
          this.tableDataList = data.records;
          this.total = data.total;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getDataMap() {
      try {
        request("getArea", {
          parentId: 1,
        }).then((data) => {
          this.provinceList = data;
        });
        request("getRobotStatusMap").then((data) => {
          this.robotStatusList = data;
        });
        request("getIndustryList").then((data) => {
          this.industryList = data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    handleClick() {
      this.getData();
    },
    searchData(data) {
      this.query = data
      this.getData()
    },
    updatePage(page, size) {
        this.page = page || 1
        this.size = size || 10
        this.getData()
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;  
  display: flex;
  flex-direction: column;
}
</style>